module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAYBAMAAAAfR1CMAAAAAXNSR0IB2cksfwAAACRQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAplgCRwAAAAx0Uk5TAFCfIGD/kLAw8MCAGa+/hgAAAEBJREFUeJxjYAABRmUGFOAahsJlCQ1ElQ51QJUOoZ+0aCgKYChF43eGRq1CAgwcU4NQ/dYZqoDCp4uCaDQFcD4AFHgkHFe/7WMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/content-view--header--back@2x.png
// module id = 802
// module chunks = 0